import { Copy } from "./icons-DcNsvqse.js";
import { Button, ButtonInline } from "./Button-B7uaj5tL.js";
import { Clipboard } from "./Clipboard-CWpd6hpe.js";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/blocks/ClipboardButton/ClipboardButton.tsx
const DEFAULT_ICON = /* @__PURE__ */ jsx(Copy, {});
const DEFAULT_ARIA_LABEL = "Copy";
const ClipboardButton = ({ text, tooltip, tooltipPlacement, tooltipVariant, icon = DEFAULT_ICON, variant = "outline", children, ...rest }) => {
	const defaultAriaLabel = typeof tooltip === "string" && tooltip.trim() ? tooltip : DEFAULT_ARIA_LABEL;
	const ariaLabel = rest["aria-label"] ?? (children == null ? defaultAriaLabel : void 0);
	return /* @__PURE__ */ jsx(Clipboard, {
		asChild: true,
		tooltip,
		tooltipPlacement,
		tooltipVariant,
		text,
		children: /* @__PURE__ */ jsxs(Button, {
			...rest,
			"aria-label": ariaLabel,
			variant,
			disabled: !text,
			children: [icon, children]
		})
	});
};
//#endregion
//#region src/blocks/ClipboardButton/ClipboardInline.tsx
const ClipboardInline = ({ text, tooltip, tooltipPlacement, tooltipVariant, children = "Copy To Clipboard", hideIcon = false, ...rest }) => /* @__PURE__ */ jsx(Clipboard, {
	asChild: true,
	text,
	tooltip,
	tooltipPlacement,
	tooltipVariant,
	children: /* @__PURE__ */ jsxs(ButtonInline, {
		...rest,
		disabled: !text,
		children: [!hideIcon && /* @__PURE__ */ jsx(Copy, { className: "tw:size-4" }), children]
	})
});
//#endregion
export { ClipboardButton, ClipboardInline };

//# sourceMappingURL=ClipboardButton-BcGUY7BE.js.map